import {
  LoginPayload,
  LoginResponse,
  RefreshTokenPayload,
  VendorHashKeyPayload,
  VendorHashKeyResponse,
  VendorLoginPayload,
  VendorLoginResponse,
} from '../models/User'
import {
  getServicePath,
  publicInstance,
  authorizedInstance,
} from './APIManager'

const SERVICE_NAME = 'wallet-member'
const SERVICE_PATH = getServicePath(SERVICE_NAME)

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  const res = await publicInstance.post(`${SERVICE_PATH}/sessions`, payload)

  return res.data as LoginResponse
}

export async function getVendorLoginHashKey(
  payload: VendorHashKeyPayload,
): Promise<VendorHashKeyResponse> {
  const res = await publicInstance.post(
    `${SERVICE_PATH}/vendor/sessions`,
    payload,
  )
  return res.data as VendorHashKeyResponse
}

export async function vendorLogin(
  payload: VendorLoginPayload,
): Promise<VendorLoginResponse> {
  const res = await publicInstance.post(
    `${SERVICE_PATH}/vendor/sessions`,
    payload,
  )
  return res.data as VendorLoginResponse
}

export function logout(): Promise<void> {
  return authorizedInstance.delete(
    `${SERVICE_PATH}/sessions`,
  ) as unknown as Promise<void>
}

export async function requestRefreshToken(
  payload: RefreshTokenPayload,
): Promise<LoginResponse> {
  const res = await publicInstance.put(`${SERVICE_PATH}/sessions`, payload)

  return res.data as LoginResponse
}
